import React from "react";

import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

import Card from "./card";
import formatDate from "../../utils/format-date";

/**
 * Renders the single-width blog card. Single-width is a stripped back double-width,
 * with no excerpt or post information besides the title and the author name.
 */
class SingleWidthCard extends Card
{
    render () 
    {
        let data = this.props.data.node ?? this.props.data;
        let type = this.props.type ?? "case-study";
        let extraClasses = this.props.extraClasses;
        let borderClasses = this.props.borderClasses;
        // temp solution while blogs don't have services
        var classes = "post-card-wrap-content-flaunt-digital";

        let date;

        if(data.date) {
            date = formatDate(data.date);
        }
        
        if ((data.primaryService && typeof data.primaryService !== "undefined") || (data.servicesTaxonomy !== null && typeof data.servicesTaxonomy !== "undefined" && data.servicesTaxonomy.nodes !== [] && data.servicesTaxonomy.nodes.length > 0))
            classes = this.getServiceClasses(data.primaryService ?? data.servicesTaxonomy.nodes[0].slug, "post-card-wrap-content");

        return (
            <article className={`post-card ${extraClasses}`}>
                <div className="post-card-wrap">
                    <this.LinkWrapper data={ data }>
                        {/* load the thumbnail if the image is valid */}
                        {this.isImageValid(data.featuredImage) ? 
                            <GatsbyImage image={ data.featuredImage.node.localFile.childImageSharp.gatsbyImageData } className="lazyload" alt="" />
                        : 
                            null
                        }
                    </this.LinkWrapper>
                    <div className={`post-card-wrap-content ${ classes } ${ borderClasses }`}>
                        { data.link 
                        ? 
                            <h3><Link to={ data.link }><span dangerouslySetInnerHTML={{ __html: data.title }} /></Link></h3>
                        :
                            <h3 className={ this.props.centerCardTitle ? "post-card-wrap-content-title_centered" : "" }><span dangerouslySetInnerHTML={{ __html: data.title }} /></h3>
                        }
                        {   data.servicesTaxonomy !== null && 
                            typeof data.servicesTaxonomy !== "undefined" && 
                            data.servicesTaxonomy.nodes !== [] && 
                            data.servicesTaxonomy.nodes.length > 0 ?
                            <div className="post-card-subheading-wrapper">
                                <span className="service-title">{ data.primaryServiceTitle ?? data.servicesTaxonomy.nodes[0].name }</span>
                                { date && type === "blog" ?
                                    <span className="post-card-date">{ date }</span>
                                :
                                    null
                                }
                            </div>
                        :
                            null
                        }
                    </div>
                </div>
            </article>
        );
    }
}

export default SingleWidthCard;